/** True on any screen under one selected client, and false on the clients list itself. */
export function isInsideClient(pathname: string): boolean {
  return /^\/clients\/[^/]+/.test(pathname)
}
